<template>
    <v-row class="mt-10">
        <v-col
            v-if="unified_kiosk_landing===1 || unified_kiosk_landing===3"
            cols="12"
            :sm="unified_kiosk_landing===1 || unified_kiosk_landing===3?6:0"
            :offset-sm="unified_kiosk_landing===1?3:0"
        >
            <v-hover
                v-slot="{ hover }"
            >
                <v-card
                    :elevation="hover ? 16 : 2"
                    :class="{ 'on-hover': hover }"
                    class="mx-auto"
                    height="400"
                    max-width="350"
                    @click="chooseRentDuration('daily')"
                >
                    <v-img
                        src="/img/snow2.jpg"
                        height="300px"
                    ></v-img>

                    <v-card-title>
                        <h3 class="mob-h3-font">Daily Reservation</h3>
                    </v-card-title>
                </v-card>
            </v-hover>
        </v-col>

        <v-col
            v-if="unified_kiosk_landing===2 || unified_kiosk_landing===3"
            cols="12"
            :sm="unified_kiosk_landing===2 || unified_kiosk_landing===3?6:0"
            :offset-sm="unified_kiosk_landing===2?3:0"
        >
            <v-hover
                v-slot="{ hover }"
            >
                <v-card
                    :elevation="hover ? 16 : 2"
                    :class="{ 'on-hover': hover }"
                    class="mx-auto"
                    height="400"
                    max-width="350"
                    @click="chooseRentDuration('seasonal')"
                >
                    <v-img
                        src="/img/snow1.jpg"
                        height="300px"
                    ></v-img>

                    <v-card-title>
                        <h3 class="mob-h3-font">Seasonal Reservation</h3>
                    </v-card-title>
                </v-card>
            </v-hover>
        </v-col>
    </v-row>
</template>

<script>
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";
import UiManagerMixin           from "../../../mixins/UiManagerMixin";
import moment from "moment";

export default {
    name   : "ReservationTypes",
    mixins : [StepperComponentMixin,UiManagerMixin],
    computed : {
        unified_kiosk_landing () {
            return parseInt(this.$store.state.resources.config.unified_kiosk_landing);
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        welcome_text_in_kiosk() {
            return parseInt(this.$store.state.resources.config.welcome_text_in_kiosk);
        }
    },
    methods: {
        async stepSubmit() {

            return true;
        },
        async chooseRentDuration(variant) {
            const newEnvironment = [...this.$store.state.meta.environment,variant];
            this.$store.commit('set_kiosk_environment', newEnvironment);

            // let season_start = moment(moment(this.$store.state.resources.config.season_start).format("YYYY-MM-DD"), 'YYYY-MM-DD');
            // let current = moment().startOf('day');
            // let diff_days = moment.duration(season_start.diff(current)).asDays();
            let offset = 1;
            let date_pickup = moment(new Date()).format("MM/DD/YYYY") <= moment(new Date(this.$store.state.resources.config.season_start)).format("MM/DD/YYYY")?this.$store.state.resources.config.season_start:moment(new Date()).format("MM/DD/YYYY");
            if (this.$store.state.model.reservation.is_seasonal) {
                this.$store.commit('set_model_value',{path:'model.reservation.date_pickup',value: date_pickup})
                this.$store.commit('set_model_value',{path:'model.reservation.date_return',value:this.$store.state.resources.config.season_return})
            }

            await this.moveToStep(this.currentStepId+offset);
        }
    },
    mounted() {
        if(this.welcome_text_in_kiosk){
            this.ui__openModalByName({name:'dialog_welcome_text'})
        }
    }
}
</script>

<style scoped>
    .on-hover {
        cursor: pointer;
    }
    .mob-h3-font{
        font-size: 1.25rem;
    }

    /*Large devices (desktops, 992px and up)*/
    @media (min-width: 992px) {
        .mob-h3-font{
            font-size: 1.575rem;
        }
    }

</style>
